import {useEffect, useState } from 'react';
import $ from 'jquery';
import { properties } from '../../properties';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';
import { getBasketCustomVars } from './BasketCustomVars';

function Auth({apiUrl}) {
    const [authorise, setAuthorise] = useState({
        operation: properties.OPERATIONS.auth,
        transactionid: transidgenerator(),
        timestamp:"",
        method:properties.HTTP_METHOD,
        vendorid: properties.VENDOR_ID,
        password: properties.PASSWORD,
        description: properties.DESCRIPTION,
        value: properties.VALUE,
        currency: properties.CURRENCY,
        region: properties.SEL_REGION,
        address: properties.ADDRESS,
        postCode: properties.POST_CODE,
        countryCode: properties.COUNTRY_CODE,
        allowAvsFail: properties.ALLOW_AVS_FAIL,
        customerId: properties.CUSTOMER_ID,
        security: "",
    });
    
    const [basketCount, setBasketCount] = useState(1);
    const [customVars, setCustomVars] = useState([]);
    const [isDpaFlag, setIsDpaFlag] = useState("false");
    
    useEffect(() => {
        const custom_vars = getBasketCustomVars(basketCount);
        setCustomVars(custom_vars);
    }, [basketCount]);

    var canSubmit = true;

    function isNotNullCheck(e, field){
        if(e === "" || !e){
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else{
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    function changeBasketCount(e) {
        setBasketCount(e.target.value);
        if (e === "" || !e || e.target.value < 1) {
            document.getElementsByName("WPG_basketCount")[0].classList.add("emptied");
            document.getElementsByName("WPG_basketCount")[1].classList.add("emptied");
            canSubmit = false;
        }
        else {
            document.getElementsByName("WPG_basketCount")[0].classList.remove("emptied");
            document.getElementsByName("WPG_basketCount")[1].classList.remove("emptied");
        }
    }

    function changeDpaFlag(e) {
        setIsDpaFlag(e.target.value);
    }
    
    function changeTransactionId(e) {
        setAuthorise({ ...authorise, transactionid: e.target.value });
        isNotNullCheck(e.target.value,"WPG_transID");
    }

    function changeVendorId(e) {
        setAuthorise({ ...authorise, vendorid: e.target.value });
        isNotNullCheck(e.target.value,"WPG_vendorID");
    }

    function changePwd(e) {
        setAuthorise({ ...authorise, password: e.target.value });
        isNotNullCheck(e.target.value,"vendorPwd");
    }

    function changeDesc(e) {
        setAuthorise({ ...authorise, description: e.target.value });
    }

    function changeValue(e) {
        setAuthorise({ ...authorise, value: e.target.value });
        isNotNullCheck(e.target.value,"WPG_value");
    }

    function changeCurrency(e) {
        setAuthorise({ ...authorise, currency: e.target.value });
        isNotNullCheck(e.target.value,"WPG_currency");
    }

    function changeAddr(e) {
        setAuthorise({ ...authorise, address: e.target.value });
    }

    function changePostCode(e) {
        setAuthorise({ ...authorise, postCode: e.target.value });
    }

    function changeCountryCode(e) {
        setAuthorise({ ...authorise, countryCode: e.target.value });
    }

    function changeRegion(e) {
        console.log(e.target.value);
        setAuthorise({ ...authorise, region: e.target.value });
        isNotNullCheck(authorise.region,"WPG_region");
    }

    function changeAvsFail(e) {
        setAuthorise({ ...authorise, allowAvsFail: e.target.value });
    }

    function changeCustomerId(e) {
        setAuthorise({ ...authorise, customerId: e.target.value });
    }

    var region =[];
    for(var property in properties.REGIONS){
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    function submitAuthorise(e) {
        e.preventDefault();
        isNotNullCheck(authorise.transactionid,"WPG_transID");
        isNotNullCheck(authorise.vendorid,"WPG_vendorID");
        isNotNullCheck(authorise.password,"vendorPwd");
        isNotNullCheck(authorise.value,"WPG_value");
        isNotNullCheck(authorise.region,"WPG_region");
        isNotNullCheck(authorise.currency,"WPG_currency");
        if(canSubmit){
            document.getElementsByClassName("loader")[0].classList.add("loading");
            if(authorise.region === "NoR"){
                setAuthorise({...authorise, region:""});
            }
            $("#pwd").remove();
            var md5 = require('md5');
            var time = Math.floor(Date.now() / 1000);
            $("#authorise_timestamp").val(time);
            var digest = md5(time + authorise.vendorid + authorise.transactionid + authorise.method + authorise.description +
                authorise.value + authorise.currency + authorise.region + authorise.address + authorise.postCode +
                authorise.countryCode + authorise.allowAvsFail + authorise.password)
            $("#authorise_security").val(digest);
            $("#authoriseForm").attr('action', apiUrl).submit();
        } 
    }

    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);
    
    var authTemplate = (
        <div className="operation-form">
            <h2>Authorise</h2>
            <form className="form-horizontal" id="authoriseForm" onSubmit={submitAuthorise} method='POST'>
                <input type="hidden" name="WPG_operation" value={authorise.operation} />
                <input type="hidden" name="WPG_method" value={authorise.method}/>
                <input type="hidden" name="WPG_CUSTOM_Operation" value={authorise.operation} />
                {/* Input box to set number of basket items */}
                <div className="form-group">
                    <div className="control-label">
                        Number of Basket Items<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="number" className="form-control" name='WPG_basketCount' value={basketCount} onChange={changeBasketCount}
                        />
                        <div className="error-msg" name="WPG_basketCount">Basket Count should be at least 1</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Dpa Flag
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_dpaFlag" value={isDpaFlag} onChange={changeDpaFlag}>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={authorise.transactionid} onChange={changeTransactionId}/>
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={authorise.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group" id="pwd">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={authorise.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description
                    </div>
                <div className="col-sm-5">
                    <input type="text" className="form-control" name="WPG_description" value={authorise.description} onChange={changeDesc} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Value<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_value" value={authorise.value} onChange={changeValue} />
                        <div className="error-msg" name="WPG_value">Value is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Currency Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_currency" value={authorise.currency} onChange={changeCurrency} />
                        <div className="error-msg" name="WPG_currency">ISO Currency Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={authorise.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Address
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_address" value={authorise.address} onChange={changeAddr} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Postal/Zip Code
                    </div>
                <div className="col-sm-5">
                    <input type="text" className="form-control" name="WPG_postcode" value={authorise.postCode} onChange={changePostCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Country Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_countryCode" value={authorise.countryCode} onChange={changeCountryCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Allow AVS Fail
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_allowAVSFail" value={authorise.allowAvsFail} onChange={changeAvsFail}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Customer Id
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_customerId" value={authorise.customerId} onChange={changeCustomerId} />
                    </div>
                </div>
                <input type="hidden" name="WPG_timestamp" id="authorise_timestamp" value="" />
                <input type="hidden" name="WPG_security" id="authorise_security" value="" />
                {customVars}
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" id="authorizeButton" className="btn btn-primary">Continue</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>
    );

    return authTemplate;
}

export default Auth;